import { Keyboard } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useApp } from "@/context/AppContext";
import { SHORTCUTS } from "@/lib/tpv";

export default function HelpDialog({ open, onClose }) {
  const { t } = useApp();
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="shortcuts-dialog">
        <DialogTitle className="font-heading text-2xl flex items-center gap-2"><Keyboard className="w-6 h-6" />{t("shortcuts")}</DialogTitle>
        <div className="grid grid-cols-2 gap-2">
          {SHORTCUTS.map(([k, label]) => (
            <div key={k} className="flex items-center gap-2 rounded-lg bg-secondary px-3 py-2">
              <kbd dir="ltr" className="min-w-12 text-center rounded-md bg-[#0B2A5B] text-white text-xs font-bold px-2 py-1">{k}</kbd>
              <span className="text-sm font-medium">{t(label)}</span>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
